import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import requester from "../../lib/requester";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import moment from "moment";
import _ from "lodash";
import ReactExport from "react-export-excel-hot-fix";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import Autocomplete from "../../component/autocomplete";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class Summary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(),
      endDate: new Date(),
      dataTable: [],
      baseTable: [],
      search: "",
      user: JSON.parse(window.localStorage.getItem("is_user")),
      fromDate: "",
      toDate: "",
      expDate: "",
      setStatus: "",
      submittedDateFrom: "",
      submittedDateTo: "",
      status: "",
      activeStatus: "",
      setBranch: "",
      setPrincipal: "",
      lovPrincipal: [],
      princid: "",
      lovBranch: [],
      export: false,
      originOrgid: "",
      customerId: 0,
      customerName: "",
      bupotexist:""
    };
  }

   

  componentDidMount = () => {
    this.getPrincipal();
    this.getBranch();
    // let url = "/api/traces/v1/claim/summary";
    // let principalGroup = this.state.user.principal_group.map((item, index) => {
    //   return item.principal_code;
    // });
    // let branchGroup = this.state.user.branch.map((item, index) => {
    //   return item.org_id;
    // });
    // let param = {
    //   group: principalGroup,
    //   branch: branchGroup,
    //   source: "arman",
    // };
    // requester.postTraces(url, param, {
    //   success: function (response) {
    //     let { data } = response.data;
    //     data.map((item, index) => {
    //       item.formatted_start_date = moment(item.start_date).format(
    //         "DD-MMM-YYYY"
    //       );
    //       item.formatted_end_date = moment(item.end_date).format("DD-MMM-YYYY");
    //       item.formatted_submitted_date = moment(item.creation_date).format(
    //         "DD-MMM-YYYY HH:mm:ss"
    //       );
    //       item.formatted_exp_date = moment(item.claim_exp_date).format(
    //         "DD-MMM-YYYY"
    //       );
    //       item.formatted_status = this.labelStatus(item);
    //       item.formatted_assigned = item.assigned_date
    //         ? moment(item.assigned_date).format("DD-MM-YYYY")
    //         : "";
    //       return item;
    //     });
    //     this.setState({ dataTable: data, baseTable: data });
    //   }.bind(this),
    //   error: function (e) {
    //     console.log(e);
    //   },
    // });
  };

  onSelectCustomer = (suggestions, index) => {
    let customer_id = 0
    let customer_name = "";
this.setState({ customerId: 0, customerName: "" });
    customer_id = suggestions.value ? suggestions.value : 0;
    customer_name = suggestions.text ? suggestions.text : null;
    this.setState({ customerId: customer_id, customerName: customer_name });
    // console.log(customerSave)
  };

  onChangeAutocompleteCust = (q) => {
    this.setState({ customerId: 0, customerName: "" });
    let param = {
      branch_id: this.state.user.org_id,
      customer_name: q,
    };
    let container = [];
    this.setState({ customerId: 0, customerName: "" });
    return new Promise((resolve) => {
      requester.postOracle("/api/orafin/v1/participant/customer", param, {
        success: function (response) {
          var api_response = response.data.data;
          container = api_response.map((item, index) => {
            item.text = item.CUSTOMER_NAME;
            item.value = item.CUSTOMER_ID;
            return item;
          });
          resolve(container);
        },
        error: function (e) {
          resolve([]);
        },
      });
    });

  };

  getBranch = () => {
    // let branchGroup = this.state.user.branch.map((item, index) => {
    //     return item.org_id
    // })

    let url = "/api/traces/v1/general/list-cabang";
    requester.getTraces(url, {
      success: function (response) {
        this.setState({ lovBranch: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });

    if (this.state.user.origin === "CAB") {
      this.state.originOrgid = this.state.user.org_id;
      this.state.setBranch = this.state.user.org_id;
    }

    // this.setState({ lovBranch: this.state.user.branch });
    console.log(this.state.originOrgid);
  };

  getPrincipal = () => {
    let url = "/api/traces/v1/general/list-principal";
    requester.getTraces(url, {
      success: function (response) {
        this.setState({ lovPrincipal: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  //   handleSearch = (e) => {
  //     let value = e.target.value;
  //     this.setState({ search: value });
  //     let baseTable = _.filter(this.state.baseTable, function (o) {
  //       return (
  //         (o.customer_name
  //           ? o.customer_name.toLowerCase().includes(value.toLowerCase())
  //           : "") ||
  //         o.description.toLowerCase().includes(value.toLowerCase()) ||
  //         o.program_number.toLowerCase().includes(value.toLowerCase()) ||
  //         o.ref_number.toLowerCase().includes(value.toLowerCase()) ||
  //         o.org_name.toLowerCase().includes(value.toLowerCase())
  //       );
  //     });
  //     this.setState({ dataTable: baseTable });
  //   };

  handleSearch = (e) => {
    
    let url = "/api/traces/v1/claim/summary";
    let principalGroup = this.state.user.principal_group.map((item, index) => {
      return item.principal_code;
    });
    let branchGroup = this.state.user.branch.map((item, index) => {
      return item.org_id;
    });
    let param = {
      export: this.state.export,
      group: principalGroup,
      branch: branchGroup,
      source: "arman",
      customerid: this.state.customerId,
      // status: this.state.setStatus,
      active_status: this.state.activeStatus,
      principal: this.state.setPrincipal,
      ebupot_exist: this.state.bupotexist,
      from_date:
        this.state.fromDate != ""
          ? moment(new Date(this.state.fromDate)).format("YYYY-MM-DD")
          : "",
      to_date:
        this.state.toDate != ""
          ? moment(new Date(this.state.toDate)).format("YYYY-MM-DD")
          : "",
      submit_from:
        this.state.submittedDateFrom != ""
          ? moment(new Date(this.state.submittedDateFrom)).format("YYYY-MM-DD")
          : "",
      submit_to:
        this.state.submittedDateTo != ""
          ? moment(new Date(this.state.submittedDateTo)).format("YYYY-MM-DD")
          : "",
      expdate:
        this.state.expDate != ""
          ? moment(new Date(this.state.expDate)).format("YYYY-MM-DD")
          : "",
    };
    requester.postTraces(url, param, {
      success: function (response) {
        let { data } = response.data;
        data.map((item, index) => {
          // item.formatted_start_date = moment(item.start_date).format(
          //   "DD-MMM-YYYY"
          // );
          // item.formatted_end_date = moment(item.end_date).format("DD-MMM-YYYY");
          // item.formatted_submitted_date = moment(item.creation_date).format(
          //   "DD-MMM-YYYY HH:mm:ss"
          // );
          // item.formatted_exp_date = moment(item.claim_exp_date).format(
          //   "DD-MMM-YYYY"
          // );
          // item.formatted_status = this.labelStatus(item);
          // item.formatted_assigned = item.assigned_date
          //   ? moment(item.assigned_date).format("DD-MM-YYYY")
          //   : "";
          return item;
        });
        this.setState({ dataTable: data, baseTable: data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  renderTable = () => {
    const data = {
      columns: [
        {
          Header: "CLAIM NO",
          accessor: "claim_number",
          filterable: true,
        },
        {
          Header: "TRACES NO",
          accessor: "skp_number",
          filterable: true,
        },
        {
          Header: "REF NO",
          accessor: "ref_number",
          filterable: true,
        },
        {
          Header: "PROGRAM TYPE",
          accessor: "program_name",
          filterable: true,
        },
        {
          Header: "DESCRIPTION",
          accessor: "description",
          filterable: true,
        },
        {
          Header: "CLAIM EXP DATE",
          accessor: "claim_exp_date",
          // filterable: true,
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
        },
        {
          Header: "SUBMITTED DATE",
          accessor: "creation_date",
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          // ,
          // filterable: true
        },
        {
          Header: "BUDGET",
          accessor: "budget",
          className: "text-right",
          // filterable: true,
          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })
                  : ""}
              </span>
            </div>
          ),
        },
        {
          Header: "AMOUNT",
          accessor: "total_claim",
          className: "text-right",
          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })
                  : ""}
              </span>
            </div>
          ),
          // ,
          // filterable: true
        },
        {
          Header: "CUSTOMER",
          accessor: "customer_name",
          filterable: true,
        },
        {
          Header: "E-Bupot Upload By",
          accessor: "ebupot_upload_by",
          filterable: true,
        },
        {
          Header: "E-Bupot Upload Date",
          accessor: "ebupot_upload_date",
          filterable: true,
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
        },
        {
          Header: "E-Bupot Download By",
          accessor: "ebupot_download_by",
          filterable: true,
        },
        {
          Header: "E-Bupot Download Date",
          accessor: "ebupot_download_date",
          filterable: true,
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
        },

        {
          Header: "STATUS",
          accessor: "status",
          filterable: true,
        },
        {
          Header: "",
          accessor: "claim_id",
          Cell: (row) => {
            return (
              <span>
                <button
                  className="btn btn-info btn-sm"
                  onClick={() => {
                    this.goDetail(row);
                  }}
                >
                  <i class="fas fa-eye"></i> View
                </button>
              </span>
            );
          },
        },
      ],
      rows: this.state.dataTable,
    };
    return (
      <ReactTable
        className="fullWidth"
        data={data.rows}
        columns={data.columns}
        defaultPageSize={10}
        defaultFilterMethod={(filter, row, column) => {
          let columnes = "";
          switch (filter.id) {
            case "start_date":
              columnes = row._original.formatted_start_date;
              break;
            case "end_date":
              columnes = row._original.formatted_end_date;
              break;
            case "claim_exp_date":
              columnes = row._original.formatted_exp_date;
              break;
            // case "status":
            //     columnes = row._original.formatted_status
            //     break;
            case "creation_date":
              columnes = row._original.formatted_submitted_date;
              break;
            default:
              columnes = row[filter.id];
          }
          console.log(columnes);

          return columnes
            ? columnes.toLowerCase().includes(filter.value.toLowerCase())
            : "";
        }}
      />
    );
  };

  handleExport = () => {
    this.setState({ export: true });
    let app = this;
    window.setTimeout(() => {
      app.handleSearch();
    }, 200);
  };

  handleChangeStatus = (e) => {
    this.state.activeStatus = e.target.value;
  };

  handleChangeBupot = (e) => {
    this.state.bupotexist = e.target.value;
  };

  handleChangePrincipal = (e) => {
    this.state.setPrincipal = e.target.value;
  };

  goDetail = (rows) => {
    let { row } = rows;
    this.props.history.push("/admin/claim/view/" + row.claim_id);
  };

  handlefromDate = (date) => {
    this.setState({ fromDate: date });
  };

  handletoDate = (date) => {
    this.setState({ toDate: date });
  };

  handleSubmittedDateFrom = (date) => {
    this.setState({ submittedDateFrom: date });
  };

  handleSubmittedDateTo = (date) => {
    this.setState({ submittedDateTo: date });
  };

  handleexpDate = (date) => {
    this.setState({ expDate: date });
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12">
                <div className="card card-info">
                  <div className="card-header">List</div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="card">
                          <div className="card-body">
                            <div className="row mt-3">
                              {/* <div className="col-md-2">Branch</div>
                              <div className="col-md-3">
                                <select
                                  className="form-control"
                                  name="branchId"
                                  onChange={this.handleChangeBranch.bind(this)}
                                >
                                  <option value="">ALL</option>
                                  {this.state.lovBranch.map((item, index) => (
                                    <option
                                      value={item.org_id}
                                      key={index}
                                      selected={
                                        this.state.originOrgid == item.org_id
                                          ? true
                                          : false
                                      }
                                    >
                                      {item.org_name}
                                    </option>
                                  ))}
                                </select>
                              </div> */}
                              {/* <div className="col-md-2">Principal</div>
                              <div className="col-md-3">
                                <select
                                  className="form-control"
                                  name="org_id"
                                  onChange={this.handleChangePrincipal.bind(
                                    this
                                  )}
                                >
                                  <option value="">ALL</option>
                                  {this.state.lovPrincipal.map(
                                    (item, index) => (
                                      <option value={item.org_id}>
                                        {item.org_name}
                                      </option>
                                    )
                                  )}
                                </select>
                              </div> */}
                            </div>

                            <div className="row">
                              <div className="col-md-2 mt-1">
                                Submitted Date From:{" "}
                              </div>
                              <div className="col-lg-3">
                                <DatePicker
                                  placeholder="Submitted Date from"
                                  selected={this.state.submittedDateFrom}
                                  dateFormat="d-MMM-yyyy"
                                  className="form-control myDatePicker"
                                  popperPlacement="bottom-end"
                                  onChange={this.handleSubmittedDateFrom}
                                />
                              </div>
                              <div className="col-md-2 mt-1">
                                Submitted Date To:{" "}
                              </div>
                              <div className="col-lg-3">
                                <DatePicker
                                  placeholder="Submitted Date from"
                                  selected={this.state.submittedDateTo}
                                  dateFormat="d-MMM-yyyy"
                                  className="form-control"
                                  popperPlacement="bottom-end"
                                  onChange={this.handleSubmittedDateTo}
                                />
                              </div>
                            </div>
                            <div className="row mt-3">
                              <div className="col-md-2 mt-1">
                                Approved Date From:{" "}
                              </div>
                              <div className="col-lg-3">
                                <DatePicker
                                  placeholder="Submitted Date from"
                                  selected={this.state.fromDate}
                                  dateFormat="d-MMM-yyyy"
                                  className="form-control"
                                  popperPlacement="bottom-end"
                                  onChange={this.handlefromDate}
                                />
                              </div>
                              <div className="col-md-2 mt-1">
                                Approved Date To:{" "}
                              </div>
                              <div className="col-lg-3">
                                <DatePicker
                                  placeholder="Submitted Date from"
                                  selected={this.state.toDate}
                                  dateFormat="d-MMM-yyyy"
                                  className="form-control"
                                  popperPlacement="bottom-end"
                                  onChange={this.handletoDate}
                                />
                              </div>
                            </div>
                            <div className="row mt-3">
                              <div className="col-md-2 mt-1">
                                Expired After{" "}
                              </div>
                              <div className="col-lg-3">
                                <DatePicker
                                  placeholder="Submitted Date from"
                                  selected={this.state.expDate}
                                  dateFormat="d-MMM-yyyy"
                                  className="form-control"
                                  popperPlacement="bottom-end"
                                  onChange={this.handleexpDate}
                                />
                              </div>
                              <div className="col-md-2">Claim Status</div>
                              <div className="col-md-3">
                                <select
                                  className="form-control"
                                  onChange={this.handleChangeStatus.bind(this)}
                                >
                                  <option value="">All</option>
                                  <option value="D">Draft</option>
                                  <option value="P">Propose</option>
                                  <option value="A">Approve</option>
                                  <option value="I">Invalid</option>
                                  <option value="E">Revise</option>
                                  <option value="R">Reject</option>
                                </select>
                              </div>
                              {/* <div className="col-md-2">Active Status</div>
                                                            <div className="col-md-3">
                                                                <select className="form-control" onChange={ this.handleChangeStatusActive.bind(this) }>
                                                                    <option value="">- Select Status -</option>
                                                                    <option value="Y">Active</option>
                                                                    <option value="N">Inactive</option>
                                                                </select>
                                                            </div> */}
                            </div>

                            <div className="row mt-3">
                              <div className="col-md-2 mt-1">Principal </div>
                              <div className="col-lg-3">
                                <select
                                  className="form-control"
                                  name="org_id"
                                  onChange={this.handleChangePrincipal.bind(
                                    this
                                  )}
                                >
                                  <option value="">ALL</option>
                                  {this.state.lovPrincipal.map(
                                    (item, index) => (
                                      <option key={index} value={item.org_id}>
                                        {item.org_name}
                                      </option>
                                    )
                                  )}
                                </select>
                              </div>
                              <div className="col-md-2">Customer</div>
                              <div className="col-md-3">
                                <Autocomplete
                                  id="customer_auto"
                                  onchange={this.onChangeAutocompleteCust.bind(
                                    this
                                  )}
                                  onselect={this.onSelectCustomer.bind(this)}
                                />
                              </div>
                            </div>
                            <div className="row mt-3">
                              <div className="col-md-2">E-Bupot</div>
                              <div className="col-md-3">
                                <select
                                  className="form-control"
                                  onChange={this.handleChangeBupot.bind(this)}
                                >
                                  <option value="">All</option>
                                  <option value="Y">Yes</option>
                                  <option value="N">No</option>
                                </select>
                              </div>
                            </div>
                            <div className="row mt-3">
                              <div className="col-md-3">
                                <button
                                  className="btn btn-primary btn-block"
                                  onClick={this.handleSearch.bind(this)}
                                >
                                  <i class="fas fa-search"></i> Search
                                </button>
                              </div>
                              {/* <div className="col-md-3">
                                <button
                                  className="btn btn-success btn-block"
                                  onClick={this.handleExport.bind(this)}
                                >
                                  <i class="fas fa-file-excel" /> Export To
                                  Excel
                                </button>
                 
                              </div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="clearfix">&nbsp;</div>
                    <div className="row">
                      <div className="col-lg-12">{this.renderTable()}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Summary;
